import { render, staticRenderFns } from "./IntegrationMain.vue?vue&type=template&id=6241e763"
import script from "./IntegrationMain.vue?vue&type=script&lang=js"
export * from "./IntegrationMain.vue?vue&type=script&lang=js"
import style1 from "./IntegrationMain.vue?vue&type=style&index=1&id=6241e763&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports